module.exports = __webpack_public_path__ + "static/img/11bg_1.dd90ff2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_1.png
// module id = 617
// module chunks = 1